import { render, staticRenderFns } from "./OutboundInboxCard.vue?vue&type=template&id=37c998d0&"
import script from "./OutboundInboxCard.vue?vue&type=script&lang=js&"
export * from "./OutboundInboxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c998d0')) {
      api.createRecord('37c998d0', component.options)
    } else {
      api.reload('37c998d0', component.options)
    }
    module.hot.accept("./OutboundInboxCard.vue?vue&type=template&id=37c998d0&", function () {
      api.rerender('37c998d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/OutboundInboxCard.vue"
export default component.exports